// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

export default function DocShareLinkDialog(props) {

  const open = props.open || false
  const shareLink = props.shareLink || ""
  const onClose = props.onClose

  const linkRef = React.useRef(null);

  const handleCloseClick = () => {
    onClose && onClose();
  }

  async function copyTextToClipboard(aText) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(aText);
    } else {
      return document.execCommand('copy', true, aText);
    }
  }


  const [openSuccessToast, setOpenSuccessToast] = useState(false);
  const handleSuccessToastClose = () => {
    setOpenSuccessToast(false);
  }
  const [openFailToast, setOpenFailToast] = useState(false);
  const handleFailToastClose = () => {
    setOpenFailToast(false);
  }

  const handleCopyClick = () => {
    copyTextToClipboard(shareLink)
      .then(() => {
        setOpenSuccessToast(true);
      })
      .catch((err) => {
        console.log(err);
        setOpenFailToast(true);
      });
  }

  return (
    <Dialog
      open={open}
      onClose={handleCloseClick}
      fullWidth={true}
      // minWidth={"lg"}
      aria-describedby="sharelink-dialog-description"
    >
      <DialogTitle id="sharelink-dialog-title">
        Share Link
      </DialogTitle>
      <DialogContent>
        <Snackbar
          open={openSuccessToast}
          autoHideDuration={2000}
          onClose={handleSuccessToastClose}
        >
          <Alert elevation={6} variant="filled" severity="success" sx={{ width: '100%' }}>
            Copied!
          </Alert>
        </Snackbar>

        <Snackbar
          open={openFailToast}
          autoHideDuration={2000}
          onClose={handleFailToastClose}
        >
          <Alert elevation={6} variant="filled" severity="error" sx={{ width: '100%' }}>
            Fail to copy into clipboard!
          </Alert>
        </Snackbar>

        <Box component="div" sx={{ display: 'flex', alignItems: 'center', }} >
          <TextField
            id="filled-basic"
            ref={linkRef}
            hiddenLabel
            size="small"
            value={shareLink}
            fullWidth
            variant="filled"
          />
          <Button onClick={() => handleCopyClick()}>
            Copy
          </Button>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Close</Button>
      </DialogActions>
    </Dialog>

  );
}

DocShareLinkDialog.propTypes = {
  open: PropTypes.bool,
  shareLink: PropTypes.string,
  onClose: PropTypes.func,
};
